import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ManageOrderDetail } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function ManageOrderDetailPage() {
    const { order_uuid, store_uuid } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('manage-order-detail-component.metatags.title'),
        description: t('manage-order-detail-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.manageOrderDetail.replace(':order_uuid', `${order_uuid}`).replace(':store_uuid', `${store_uuid}`),
        index: false,
    });

    return <ManageOrderDetail />;
}
